export default __webpack_public_path__ + "static/media/867.7ac74392.jpg";